import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import {
	Container,
  FormGroup,
  Label,
  Button,
  Form,
  Input,
  Col,
  Card,
  CardBody,
  CardTitle,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as url from "../../helpers/url_helper"
import {API_URL} from "../../helpers/api_helper";

class EnterpriseConfigEdit extends Component {
  constructor(props) {
    super(props)
    this.state = {
      field: "",
      value: "",
      _id: ""
    }
  }
  updateItem = (e) => {
    // e.preventDefault();
    console.log(e);
    this.setState({
      field: e.field,
      coin: e.coin,
      _id: e._id
    })
  }
  	componentDidMount(){
		const { data } = this.props.location
		  const {field, coin, _id } = data;
		  this.setState({
			field,
			coin,
			_id
		})
	}
	handleValidSubmit = (e) => {
		e.preventDefault();
		const { game } = this.props.location;
		const data = this.state;
		const { field, coin, _id } = data;
		console.log({field, coin, _id})
		const BToken = localStorage.getItem("gameAuth");
		const BearerToken = JSON.parse(BToken);

		fetch(`${API_URL}${url.PUT_DASHBOARD_GAME_CONFIG}/${_id}`, {
			method: 'put',
			headers: {
				'Authorization': `${BearerToken}`,
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				field,
				coin,
			})
		})
		.then(res => res.json())
		.then(data => {
			const {
				status,
				entity
			} = data ;
			if(status) {
				if(game === 'Mafia') {
					this.props.history.push("/enterprise/mafia-config")
				} else if(game === 'Werewolf') {
					this.props.history.push("/enterprise/werewolf-config")
				} else if(game === 'Resistance') {
					this.props.history.push("/enterprise/resistance-config")
				} else if(game === 'Avalon') {
					this.props.history.push("/enterprise/avalon-config")
				}				
			}
		})
	}

	handleInputChange = (e) => {
		this.setState({
			[e.target.name] : e.target.value
		})
	}


  render() {
	  const {field, coin, _id } = this.state;
    return (
      <React.Fragment>
		  <div className="page-content">
          <MetaTags>
            <title>Game | AP - Mafia</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={("Game Config")}
              breadcrumbItem={("Edit Config")}
            />
        <Col md={12}>
          <Card>
            <CardBody>
              	<CardTitle className="h4"></CardTitle>

				  <Form onSubmit={this.handleValidSubmit}>
						<FormGroup className="row mb-4">
						<Label
							htmlFor="horizontal-field-Input"
							className="col-sm-1 col-form-label text-md-right"
							style={{textAlign: "center"}}
						>
							Field
						</Label>
						<Col sm={6}>
							<Input
							value={field}
							type="text"
							name="field"
							className="form-control"
							id="horizontal-field-Input"
							onChange={this.handleInputChange}
							readOnly
							/>
						</Col>
						</FormGroup>
						<FormGroup className="row mb-4">
						<Label
							htmlFor="horizontal-coin-Input"
							className="col-sm-1 col-form-label text-md-right"
							style={{textAlign: "center"}}
						>
							Value
						</Label>
						<Col sm={6}>
							<Input
							value={coin}
							type="number"
							name="coin"
							className="form-control"
							id="horizontal-coin-Input"
							onChange={this.handleInputChange}
							required
							/>
						</Col>
						</FormGroup>

						<FormGroup className="row justify-content-end">
						<Col sm={11}>
							<div>
							<Button
								type="submit"
								color="primary"
								className="w-md"
							>
								Update
							</Button> &nbsp; &nbsp; &nbsp; <span className="loading"></span>
							</div>
						</Col>
						</FormGroup>
					</Form>
            </CardBody>
          </Card>
        </Col>

		</Container>
        </div>
	  </React.Fragment>
    )
  }
}

EnterpriseConfigEdit.propTypes = {
	t: PropTypes.any
}
export default EnterpriseConfigEdit
